import AdminSidebar from './AdminSidebar';
import { useTheme } from '@/context/ThemeContext';

const AdminLayout = ({ user, onLogout, children }) => {
  const { mode, fonts } = useTheme();
  const isDark = mode === 'dark';
  
  return (
    <div 
      className={`min-h-screen transition-colors duration-300 ${isDark ? 'bg-slate-900' : 'bg-gray-50'}`}
      style={{ 
        fontFamily: `var(--font-body, "${fonts?.body || 'Inter'}", sans-serif)`
      }}
    >
      <AdminSidebar user={user} onLogout={onLogout} />
      <div className={`lg:ml-64 p-4 md:p-6 lg:p-8 ${isDark ? 'text-white' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
